import { render, staticRenderFns } from "./FavoriteMessage.vue?vue&type=template&id=fabf9402&scoped=true"
import script from "./FavoriteMessage.vue?vue&type=script&lang=js"
export * from "./FavoriteMessage.vue?vue&type=script&lang=js"
import style0 from "./FavoriteMessage.vue?vue&type=style&index=0&id=fabf9402&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fabf9402",
  null
  
)

export default component.exports